module.exports = Backbone.Model.extend({
	urlRoot: function() {
		return App.alertsRoot + 'crowd/alerts'
	}
})
